import React from 'react';
import env from '../../env';
import { SiteLink} from '../../components';
import { usePost } from '../../components';
import { ErrorPopup, Loading } from '../../components';
import { useRouter } from '../../components';
import { AtdwSearchResult } from '../atdw/atdwSearchResult/atdwSearchResult';

export function SearchResult(props) {
  const { query } = useRouter();
  const post = usePost();
  const keyword = query.q;
  //console.log(keyword);

  React.useEffect(() => {
    post.send(env.apiBase + '/api/search/search', { keyword: keyword });
    // eslint-disable-next-line
  }, [keyword]);

  if (post.loading()) {
    return <Loading />
  } else if (post.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={post.errors} />
  }

  const data = post.response;

  const pages = data.pages;
  const atdws = data.atdws || [];

  if (pages.length === 0 && atdws.length === 0) return (
    <div className="alert alert-danger" role="alert">
      No result found.
    </div>
  )
  return (
    <section style={{maxWidth: '1200px', margin: '0 auto'}}>
        <h3 className="searchResult__title">Search Results</h3>
      {atdws.length > 0 && <div>
        <AtdwSearchResult atdwData={atdws} />
      </div>}
      {pages.length > 0 && <div>
        <PageList pages={pages} />
      </div>}
    </section>
  );
}

function PageList({pages}) {
  return (
    <div className="pageList">
      {pages.map((page, index) =>
        <div className="pageListItem" key={index}>
          <div className="pageListItem__inner">
            <SiteLink className="pageListItem__title" to={page.pageUrl}>{page.pageTitle}</SiteLink>
            <div className="pageListItem__highlight" dangerouslySetInnerHTML={{ __html: page.searchHighlight }}></div>
          </div>
        </div>
      )}
    </div>
  );
}